
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    label: {
      type: String,
      default: ''
    }
  },
  emits: {
    'file-select': null
  },
  data() {
    return {
      fileName: '',
      url: ''
    }
  },
  computed: {
    parsedURL(): URL | null {
      try {
        return new URL(this.url)
      } catch {
        return null
      }
    }
  },

  methods: {
    handleFileChange(event: any) {
      if (!event.currentTarget) {
        return
      }
      let target = event.currentTarget! as HTMLInputElement
      if (target.files == null || target.files.length < 1) {
        return
      }
      const selectedFile = target.files![0]
      this.$emit('file-select', selectedFile)
      // If user selects a file, clear the URL component
      this.url = ''
      this.fileName = target.files![0].name
    },
    dragover(event: DragEvent) {
      event.preventDefault()
      if (!event.currentTarget) {
        return
      }
      let target = event.currentTarget! as HTMLInputElement
      if (!target.classList.contains('file-hover')) {
        target.classList.add('file-hover')
      }
    },
    dragleave(event: DragEvent) {
      if (!event.currentTarget) {
        return
      }
      let target = event.currentTarget! as HTMLInputElement
      target.classList.remove('file-hover')
    },
    drop(event: DragEvent) {
      event.preventDefault()
      if (!event.currentTarget) {
        return
      }
      let target = event.currentTarget! as HTMLInputElement
      if (!event.dataTransfer || event.dataTransfer.files.length == 0) {
        return
      }
      target.files = event.dataTransfer.files
      this.handleFileChange(event)
      target.classList.remove('file-hover')
    },
    urlKeyup(event: KeyboardEvent) {
      console.log(this.url)
      if (event.key == 'Enter') {
        const target = event.target as HTMLInputElement
        if (this.parsedURL == null) {
          console.error(`${target.value} is an invalid URL`)
          return
        }
        this.$emit('file-select', this.parsedURL)
      }
    }
  }
})
